import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";

import axios from "../../../config/axios";
import { PhotoContext } from "../../../contexts/Apprenants/PhotoProvider";
import { Spinner } from "../../../components/ui/spinner";

export function ProjetCfp() {
  const location = useLocation();
  const idDossier = location.state?.idFolder;
  const [projectsFolder, setProjectsFolder] = useState([]);
  const { searchTerm } = useContext(PhotoContext);

  useEffect(() => {
    if (!idDossier) return;

    const fetchProjects = async () => {
      try {
        const responseData = await axios.get(
          `/cfp/gallery/project/${idDossier}`
        );
        setProjectsFolder(responseData.data);
      } catch (err) {
        console.error("Erreur lors du chargement des projets:", err);
      }
    };

    fetchProjects();
  }, [idDossier]);

  if (projectsFolder.length === 0) return <Spinner />;
  //   console.log(projectsFolder);
  const results =
    projectsFolder.projets?.filter((item) =>
      [item.moduleName, item.ville_name, item.dateDebut, item.dateFin].some(
        (field) =>
          field?.toLowerCase().includes(searchTerm?.toLowerCase() || "")
      )
    ) || [];

  return (
    <main className="px-4 py-6 mx-auto space-y-8 max-w-7xl sm:px-6 lg:px-8">
      <div className="flex flex-col gap-4 sm:flex-row" id="div_search"></div>
      <div id="project_list">
        <Dashboard
          nomDossier={projectsFolder.nomDossier}
          minDate={projectsFolder.minDate}
          maxDate={projectsFolder.maxDate}
          projets={results}
        />
      </div>
    </main>
  );
}

const Dashboard = ({ nomDossier, minDate, maxDate, projets = [] }) => {
  const navigate = useNavigate();
  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-4">
      <div className="flex items-center gap-4">
        <button
          className="inline-flex items-center text-gray-600 hover:text-gray-900"
          onClick={() => navigate(-1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left h-6 w-6"
          >
            <path d="m15 18-6-6 6-6"></path>
          </svg>
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{nomDossier}</h1>
          <div className="flex items-center mt-2 text-sm text-gray-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-calendar h-4 w-4 mr-1"
            >
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            <span>
              {minDate} - {maxDate}
            </span>
          </div>
        </div>
      </div>

      {projets.length > 0 ? (
        <div className="grid gap-4 justify-center grid-cols-[repeat(auto-fill,minmax(250px,1fr))]">
          {projets.map((projet) => (
            <div
              key={projet.idProjet}
              onClick={() =>
                navigate("/cfp/photos/ajout", {
                  state: {
                    idProjet: projet.idProjet,
                    project_titre: projet.moduleName,
                    start_date: projet.dateDebut,
                    end_date: projet.dateFin,
                  },
                })
              }
              className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-video relative bg-gray-100">
                <div className="absolute inset-0 flex items-center justify-center">
                  {projet.image ? (
                    <img
                      src={projet.image}
                      alt={projet.moduleName}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-image h-12 w-12 text-gray-300"
                    >
                      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
                      <circle cx="9" cy="9" r="2" />
                      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                    </svg>
                  )}
                </div>
              </div>

              {/* Texte */}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {projet.moduleName}
                </h3>
                <p className="text-sm text-gray-600 mb-3">
                  {projet.ville_name}
                </p>
                <div className="flex flex-col gap-2">
                  <div className="flex items-center text-sm text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-folder-open h-4 w-4 mr-1"
                    >
                      <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" />
                    </svg>
                    <span>{projet.countImage} photos</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-4 w-4 mr-1"
                    >
                      <path d="M8 2v4"></path>
                      <path d="M16 2v4"></path>
                      <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                      <path d="M3 10h18"></path>
                    </svg>
                    <span>
                      {projet.dateDebut} - {projet.dateFin}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>Aucun projet</p>
      )}
    </main>
  );
};
